import { useState, useEffect } from 'react';
import { Dimensions } from 'react-native';

const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState({
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').height
  });

  const [isMobile, setIsMobile] = useState(dimensions.width < 768);
  const [isTablet, setIsTablet] = useState(dimensions.width >= 768 && dimensions.width < 1024);
  const [isSmallDesktop, setIsSmallDesktop] = useState(dimensions.width >= 1024 && dimensions.width <= 1500);
  const [isLargeDesktop, setIsLargeDesktop] = useState(dimensions.width > 1500);

  useEffect(() => {
    const handleResize = () => {
      const { width, height } = Dimensions.get('window');
      setDimensions({ width, height });
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsSmallDesktop(width >= 1024 && width <= 1500);
      setIsLargeDesktop(width > 1500);
    };

    // Set up event listener
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      
      // Initial check
      handleResize();
      
      // Clean up
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return {
    ...dimensions,
    isMobile,
    isTablet,
    isSmallDesktop,
    isLargeDesktop
  };
};

export default useWindowDimensions; 